export default {"src":"/_next/static/media/pool-completed.0ad22f55.svg","height":24,"width":24};